// backend/src/utils/errors/graphqlErrors.ts

export const GraphqlErrorCodeEnum = {
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  DUPLICATED_RECORD: 'DUPLICATED_RECORD',
} as const;
